import {PATH} from "./routes";

export const menuItems = [
    {label: 'Despre noi', path: PATH.HOME},
    {label: 'Excursii școlare', path: PATH.CHILD},
    {label: 'Excursii seniori', path: PATH.SENIOR},
    {label: 'Fonduri nerambursabile', path: PATH.FUNDS},
    {label: 'Închiriere autocare', path: PATH.RENT},
    {label: 'Echipa', path: PATH.TEAM},
    {label: 'Contact', path: PATH.CONTACT},
];